<template>
  <Teleport to="body">
    <transition name="modal-fade">
      <div v-if="isVisible" class="modal-backdrop" @click.self="$emit('cancel')">
        <div class="modal-container" :class="{ wide }">
          <header class="modal-header">
            <h2>{{ title }}</h2>
          </header>
          <section class="modal-body">
            <slot>
              <p>{{ message }}</p>
            </slot>
          </section>
          <footer class="modal-footer" :class="{ split: !!secondaryLabel }">
            <button
              v-if="secondaryLabel"
              type="button"
              class="btn-secondary"
              @click="$emit('secondary')"
            >
              {{ secondaryLabel }}
            </button>
            <div class="modal-footer-end">
              <button
                v-if="!hideCancel"
                @click="$emit('cancel')"
                class="btn-secondary"
              >
                {{ cancelLabel }}
              </button>
              <button @click="$emit('confirm')" class="btn-primary">
                {{ confirmLabel }}
              </button>
            </div>
          </footer>
        </div>
      </div>
    </transition>
  </Teleport>
</template>

<script setup>
defineProps({
  isVisible: Boolean,
  title: String,
  message: String,
  wide: Boolean,
  hideCancel: Boolean,
  confirmLabel: {
    type: String,
    default: "Confirm",
  },
  cancelLabel: {
    type: String,
    default: "Cancel",
  },
  secondaryLabel: {
    type: String,
    default: "",
  },
});
defineEmits(["confirm", "cancel", "secondary"]);
</script>

<style scoped>
.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
}

.modal-container {
  width: 100%;
  max-width: 500px;
  max-height: 90vh;
  background-color: #0a0a14;
  border: 1px solid #00f6ff;
  border-radius: 10px;
  box-shadow: 0 0 30px rgba(0, 246, 255, 0.5);
  display: flex;
  flex-direction: column;
}

.modal-container.wide {
  max-width: 720px;
}

.modal-header {
  padding: 1.5rem;
  border-bottom: 1px solid rgba(0, 246, 255, 0.3);
}
.modal-header h2 {
  margin: 0;
  text-align: center;
}

.modal-body {
  padding: 1.5rem;
  color: #c0c0c0;
  line-height: 1.6;
  overflow-y: auto;
  min-height: 0;
}

.modal-footer {
  padding: 1.5rem;
  border-top: 1px solid rgba(0, 246, 255, 0.3);
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
}

.modal-footer.split {
  justify-content: space-between;
  align-items: center;
}

.modal-footer-end {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  margin-left: auto;
}

.btn-primary {
  /* Inherits global button styles */
}

.btn-secondary {
  /* Inherits global button styles */
  background-color: transparent;
  border-color: #556c88;
  color: #a9b1d6;
  box-shadow: none;
}
.btn-secondary:hover {
  background-color: rgba(169, 177, 214, 0.2);
  border-color: #a9b1d6;
}

.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.3s ease;
}
.modal-fade-enter-from,
.modal-fade-leave-to {
  opacity: 0;
}
</style>
